
export const productInfoFields = [
  { name: "sfdaId", label: "SFDA ID", type: "number" },
  { name: "registerNumber", label: "Register Number*" },
  { name: "registerYear", label: "Register Year", type: "number" },
  { name: "gtin", label: "GTIN" },
  { name: "tradeName", label: "Trade Name*" },
  { name: "scientificName", label: "Scientific Name" },
  { name: "descriptionCode", label: "Description Code" },
  { name: "scientificCode", label: "Scientific Code" },
];

export const dosageFields = [
  { name: "strength", label: "Strength" },
  { name: "strengthUnit", label: "Strength Unit" },
  { name: "pharmaceuticalForm", label: "Pharmaceutical Form" },
  { name: "administrationRoute", label: "Administration Route" },
  { name: "drugType", label: "Drug Type" },
  { name: "subType", label: "Sub Type" },
];

export const packagingFields = [
  { name: "size", label: "Size" },
  { name: "sizeUnit", label: "Size Unit" },
  { name: "packageSize", label: "Package Size", type: "number" },
  { name: "packageTypes", label: "Package Types" },
];

export const classificationFields = [
  { name: "legalStatus", label: "Legal Status" },
  { name: "legalStatusEn", label: "Legal Status (EN)" },
  { name: "legalStatusAr", label: "Legal Status (AR)" },
  { name: "productControl", label: "Product Control" },
  { name: "productControlAr", label: "Product Control (AR)" },
  { name: "publicPrice", label: "Public Price" },
  { name: "domainEn", label: "Domain (EN)" },
  { name: "domainAr", label: "Domain (AR)" },
  { name: "distributionArea", label: "Distribution Area" },
];

export const manufacturerFields = [
  { name: "marketingCompany", label: "Marketing Company" },
  { name: "marketingStatus", label: "Marketing Status" },
  { name: "authorizationStatus", label: "Authorization Status" },
  { name: "manufacturerName", label: "Manufacturer Name" },
  { name: "manufacturerCountry", label: "Manufacturer Country" },
  { name: "additionalManufacturer", label: "Additional Manufacturer" },
  {
    name: "additionalManufacturerCountry",
    label: "Addl Manufacturer Country",
  },
  { name: "companyCountryEn", label: "Company Country (EN)" },
  { name: "companyCountryAr", label: "Company Country (AR)" },
  { name: "agent", label: "Agent" },
];

export const additionalFields = [
  { name: "atcCode1", label: "ATC Code 1" },
  { name: "atcCode2", label: "ATC Code 2" },
  { name: "shelfLife", label: "Shelf Life (Months)", type: "number" },
  { name: "storageConditions", label: "Storage Conditions" },
  { name: "imageUrl", label: "Image URL" },
];

export const combinationsFields = [
  {
    name: "drugCombinationsScientificName",
    label: "Comb. Scientific Name",
  },
  { name: "drugCombinationsStrengthValue", label: "Comb. Strength Val" },
  { name: "drugCombinationsStrengthUnit", label: "Comb. Strength Unit" },
];

export const allSections = [
  { title: "Product Information", fields: productInfoFields },
  { title: "Dosage & Administration", fields: dosageFields },
  { title: "Packaging", fields: packagingFields },
  { title: "Classification & Pricing", fields: classificationFields },
  { title: "Manufacturer & Marketing", fields: manufacturerFields },
  { title: "Additional Details", fields: additionalFields },
  { title: "Combinations", fields: combinationsFields },
];
